import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { companyInfo } from '../data';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: 'Forside', path: '/' },
    { label: 'Events', path: '/events' },
    { label: 'Individuelle sessioner', path: '/sessioner' },
    { label: 'Om Johanne', path: '/om-johanne' },
    { label: 'Kontakt', path: '/kontakt' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-brand-cream/95 backdrop-blur-md border-b border-brand-sand transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group py-1">
            <img 
              src="https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/chatgpt-image-10-sep-2026-10-26-43.png" 
              alt="Johanne Eis - Spirituel Livsskabelse" 
              className="h-14 sm:h-16 md:h-18 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.02]"
            />
          </Link>

          {/* Desktop Navigation (>= 1200px) */}
          <nav className="hidden min-[1200px]:flex items-center gap-8">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `font-sans text-sm font-medium tracking-wide transition-all duration-300 relative py-2 hover:text-brand-green ${
                    isActive 
                      ? 'text-brand-green after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-brand-green' 
                      : 'text-brand-dark/80'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/events"
              className="bg-brand-green hover:bg-brand-green/90 text-brand-cream px-5 py-2.5 rounded-full text-sm font-medium tracking-wide transition-all duration-300 shadow-sm hover:shadow-md"
            >
              Se kommende events
            </Link>
          </nav>

          {/* Mobile Menu Button (< 1200px) */}
          <div className="flex min-[1200px]:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="text-brand-dark/80 hover:text-brand-green p-2 transition-colors duration-300 focus:outline-none"
              aria-label="Toggle menu"
            >
              <i className={`fa-light ${isOpen ? 'fa-xmark' : 'fa-bars'} text-2xl`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu (< 1200px) */}
      <div 
        className={`min-[1200px]:hidden transition-all duration-300 ease-in-out border-b border-brand-sand bg-brand-cream ${
          isOpen ? 'max-h-screen opacity-100 py-4' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="px-4 pt-2 pb-4 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl text-base font-medium transition-all duration-300 ${
                  isActive 
                    ? 'bg-brand-sand text-brand-green font-semibold' 
                    : 'text-brand-dark/80 hover:bg-brand-sand/50 hover:text-brand-green'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <div className="pt-4 px-4">
            <Link
              to="/events"
              onClick={() => setIsOpen(false)}
              className="block text-center bg-brand-green hover:bg-brand-green/90 text-brand-cream py-3 rounded-full text-base font-medium tracking-wide transition-all duration-300 shadow-sm"
            >
              Se kommende events
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
